document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-new-marquee]').forEach(function (marquee) {
    var track = marquee.querySelector('[data-new-marquee-track]');
    var group = marquee.querySelector('[data-new-marquee-group]');
    if (!track || !group) return;

    var speedPx = parseFloat(marquee.getAttribute('data-speed-px'), 10) || 60;

    function start() {
      var groupWidth = group.getBoundingClientRect().width;
      if (groupWidth <= 0) return;
      var duration = groupWidth / speedPx;
      marquee.style.setProperty('--new-marquee-duration', duration + 's');
      track.classList.add('is-ready');
    }

    // Wait until EVERYTHING (CSS, fonts, images) is fully loaded before
    // measuring even once — measuring too early was the bug.
    if (document.readyState === 'complete') {
      start();
    } else {
      window.addEventListener('load', start);
    }

    document.addEventListener('visibilitychange', function () {
      track.style.animationPlayState = document.hidden ? 'paused' : 'running';
    });
  });
});